import * as z from "zod";

export const createTeamSlackChannel = {
  name: "createTeamSlackChannel" as const,
  input: z.object({
    teamId: z.string(),
    // Optional override; when omitted the server defaults to "<team-name>-redo".
    channelName: z.string().optional(),
  }),
  output: z.object({
    success: z.boolean(),
    channelId: z.string().optional(),
    channelName: z.string().optional(),
    channelUrl: z.string().optional(),
    intercomInvited: z.boolean().optional(),
    creatorInvited: z.boolean().optional(),
    warning: z.string().optional(),
    error: z.string().optional(),
  }),
};
